import { type AccessRoleCode, AccessRoleCodes } from "Models/AccessRoleCodes";

export const SETTLEMENT_USER_ROLES = [
  AccessRoleCodes.Merchant,
  AccessRoleCodes.Hunter,
  AccessRoleCodes.HunterPlus,
] as const;

export type SettlementUserRole = (typeof SETTLEMENT_USER_ROLES)[number];

export const isSettlementUserRole = (
  userRole: AccessRoleCode | null,
): userRole is SettlementUserRole =>
  userRole !== null &&
  SETTLEMENT_USER_ROLES.includes(userRole as SettlementUserRole);
